import React from 'react';
import IconMC from '../../../../components/IconMC';

const PlaygroundCustomerSelect = ({
  value,
  options,
  sessionValue = '',
  sessionLabel,
  label,
  onChange
}) => (
  <label className="tw-flex tw-flex-col tw-gap-1.5 tw-min-w-0 tw-w-full">
    <span className="tw-text-xs tw-font-medium tw-text-gray-500">
      {label}
    </span>
    <span className="tw-relative tw-block tw-w-full">
      <select
        value={value}
        onChange={onChange}
        aria-label={label}
        className="tw-appearance-none tw-w-full tw-h-9 tw-text-sm tw-text-gray-800 tw-border tw-border-gray-200 tw-rounded-lg tw-pl-3 tw-pr-8 tw-bg-gray-50 tw-cursor-pointer focus:tw-outline-none focus:tw-border-blue-400"
      >
        <option value={sessionValue}>{sessionLabel}</option>
        {options.map((option) => (
          <option key={option.id} value={option.id}>
            {option.label}
          </option>
        ))}
      </select>
      <IconMC
        name="arrow-ios-downward-outline"
        size="sm"
        className="tw-pointer-events-none tw-absolute tw-right-2 tw-top-1/2 -tw-translate-y-1/2 tw-text-gray-400"
      />
    </span>
  </label>
);

export default PlaygroundCustomerSelect;
